(() => {
  const root = document.getElementById('EloGlazeMatch');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const redeemedKey = root.dataset.redeemedKey || 'elo_glaze_match_redeemed_v1';
  const pendingKey = root.dataset.pendingKey || 'elo_glaze_match_pending_reward_v1';
  const cookieName = 'elo_glaze_match_redeemed';
  const shadeData = [
    { id: 'strawberry', name: 'Strawberry Sprinkles' },
    { id: 'maple', name: 'Maple Glaze' },
    { id: 'chocolate', name: 'Chocolate Frosting' },
  ];

  const dialog = root.querySelector('.elo-glaze-match__dialog');
  const grid = root.querySelector('[data-elo-memory-grid]');
  const gameMessage = root.querySelector('[data-elo-game-message]');
  const attemptsLabel = root.querySelector('[data-elo-attempts]');
  const form = root.querySelector('#EloGlazeMatchForm');
  const emailInput = root.querySelector('#EloGlazeMatchEmail');
  const formError = root.querySelector('[data-elo-form-error]');
  const formSuccess = root.querySelector('[data-elo-form-success]')?.value === 'true';
  const formHasErrors = root.querySelector('[data-elo-form-has-errors]')?.value === 'true';
  const tagsInput = root.querySelector('[data-elo-tags]');
  const rewardChip = root.querySelector('[data-elo-reward-chip]');
  const rewardPercent = root.querySelector('[data-elo-reward-percent]');
  const rewardTitle = root.querySelector('[data-elo-reward-title]');
  const discountCode = root.querySelector('[data-elo-discount-code]');
  const copyButton = root.querySelector('[data-elo-copy]');
  const closeButtons = root.querySelectorAll('[data-elo-glaze-close]');
  const steps = {
    game: root.querySelector('[data-elo-step="game"]'),
    reward: root.querySelector('[data-elo-step="reward"]'),
    success: root.querySelector('[data-elo-step="success"]'),
  };

  let flippedCards = [];
  let attemptsLeft = 3;
  let rewardValue = 15;
  let boardLocked = false;
  let openTimer = null;
  let lastFocusedElement = null;

  function safeStorageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function safeStorageRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      // Storage may be unavailable in strict privacy modes.
    }
  }

  function hasRedeemedCookie() {
    return document.cookie
      .split(';')
      .map((part) => part.trim())
      .some((part) => part.indexOf(cookieName + '=1') === 0);
  }

  function hasRedeemed() {
    return safeStorageGet(window.localStorage, redeemedKey) !== null || hasRedeemedCookie();
  }

  function markRedeemed(value) {
    safeStorageSet(window.localStorage, redeemedKey, JSON.stringify(value));
    document.cookie =
      cookieName +
      '=1; max-age=31536000; path=/; SameSite=Lax' +
      (window.location.protocol === 'https:' ? '; Secure' : '');
  }

  function getPendingReward() {
    const value = Number.parseInt(safeStorageGet(window.sessionStorage, pendingKey), 10);
    return value === 10 ? 10 : 15;
  }

  function hasPendingReward() {
    const value = safeStorageGet(window.sessionStorage, pendingKey);
    return value === '10' || value === '15';
  }

  function setPendingReward(value) {
    safeStorageSet(window.sessionStorage, pendingKey, String(value));
  }

  function shuffle(items) {
    const result = items.slice();
    for (let index = result.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      const current = result[index];
      result[index] = result[randomIndex];
      result[randomIndex] = current;
    }
    return result;
  }

  function setStep(name) {
    Object.entries(steps).forEach(([stepName, element]) => {
      element?.classList.toggle('is-active', stepName === name);
    });
  }

  function updateAttempts() {
    if (!attemptsLabel) return;
    attemptsLabel.textContent = attemptsLeft === 1 ? '1 опит' : attemptsLeft + ' опита';
  }

  function createCard(shade, index) {
    const card = document.createElement('button');
    card.className = 'elo-glaze-match__card';
    card.type = 'button';
    card.dataset.shade = shade.id;
    card.setAttribute('aria-label', 'Скрита глазура ' + (index + 1));
    card.innerHTML =
      '<span class="elo-glaze-match__card-inner">' +
        '<span class="elo-glaze-match__face elo-glaze-match__front">' +
          '<span class="elo-glaze-match__front-mark">ÉLO</span>' +
          '<span class="elo-glaze-match__front-label">flip your glaze</span>' +
        '</span>' +
        '<span class="elo-glaze-match__face elo-glaze-match__back" data-shade="' + shade.id + '">' +
          '<svg class="elo-glaze-match__product-art" viewBox="0 0 96 240" aria-hidden="true" focusable="false">' +
            '<rect class="elo-glaze-match__product-crimp" x="10" y="8" width="76" height="15" rx="3"></rect>' +
            '<path class="elo-glaze-match__product-crimp-lines" d="M17 10v11M24 10v11M31 10v11M38 10v11M45 10v11M52 10v11M59 10v11M66 10v11M73 10v11M80 10v11"></path>' +
            '<path class="elo-glaze-match__product-body" d="M12 22h72L75 132c-1 12-5 19-14 24H35c-9-5-13-12-14-24L12 22Z"></path>' +
            '<path class="elo-glaze-match__product-highlight" d="M25 30 31 128c1 8 4 13 10 17"></path>' +
            '<rect class="elo-glaze-match__product-neck" x="26" y="150" width="44" height="12" rx="5"></rect>' +
            '<path class="elo-glaze-match__product-cap" d="M28 158h40v58c0 10-8 16-18 16h-4c-10 0-18-6-18-16v-58Z"></path>' +
            '<path class="elo-glaze-match__product-cap-highlight" d="M36 165v47c0 7 4 11 10 12"></path>' +
            '<rect class="elo-glaze-match__product-clear-base" x="31" y="218" width="34" height="9" rx="4"></rect>' +
            '<g class="elo-glaze-match__product-logo" transform="translate(54 36) rotate(90)">' +
              '<text x="0" y="0" textLength="78" lengthAdjust="spacingAndGlyphs">ÉLO BEAUTY</text>' +
              '<text class="elo-glaze-match__product-subline" x="2" y="12" textLength="48" lengthAdjust="spacingAndGlyphs">PEPTIDE LIP BALM</text>' +
            '</g>' +
          '</svg>' +
          '<span class="elo-glaze-match__shade-name">' + shade.name + '</span>' +
        '</span>' +
      '</span>';
    card.addEventListener('click', () => flipCard(card));
    return card;
  }

  function renderCards() {
    if (!grid) return;
    grid.innerHTML = '';
    const deck = shuffle(shadeData.concat(shadeData));
    deck.forEach((shade, index) => grid.appendChild(createCard(shade, index)));
  }

  function resetGame() {
    flippedCards = [];
    attemptsLeft = 3;
    rewardValue = 15;
    boardLocked = false;
    updateAttempts();
    if (gameMessage) {
      gameMessage.textContent = 'Избери първата си карта.';
      gameMessage.classList.remove('is-match');
    }
    setStep('game');
    renderCards();
  }

  function setRewardUI(value) {
    rewardValue = value === 10 ? 10 : 15;
    if (rewardChip) {
      rewardChip.textContent = rewardValue === 15 ? 'It’s a match' : 'Glow consolation';
    }
    if (rewardPercent) rewardPercent.textContent = rewardValue + '% OFF';
    if (rewardTitle) {
      rewardTitle.textContent =
        rewardValue === 15
          ? 'Твоята глазирана изненада е отключена.'
          : 'Всеки заслужава малко ÉLO glow.';
    }
    if (discountCode) {
      discountCode.textContent = rewardValue === 15 ? 'ELOGLOW15' : 'ELOGLOW10';
    }
    if (tagsInput) {
      tagsInput.value = 'newsletter,elo-glaze-match,elo-glaze-match-' + rewardValue;
    }
  }

  function showReward(value) {
    boardLocked = true;
    setRewardUI(value);
    setPendingReward(rewardValue);
    setStep('reward');
    window.setTimeout(() => emailInput?.focus(), 120);
  }

  function flipCard(card) {
    if (
      boardLocked ||
      card.classList.contains('is-flipped') ||
      card.classList.contains('is-matched')
    ) {
      return;
    }

    card.classList.add('is-flipped');
    card.setAttribute('aria-label', card.querySelector('.elo-glaze-match__shade-name')?.textContent || 'Нюанс');
    flippedCards.push(card);

    if (flippedCards.length === 1) {
      if (gameMessage) gameMessage.textContent = 'Сега открий същата глазура.';
      return;
    }

    boardLocked = true;
    const first = flippedCards[0];
    const second = flippedCards[1];
    const isMatch = first.dataset.shade === second.dataset.shade;

    if (isMatch) {
      first.classList.add('is-matched');
      second.classList.add('is-matched');
      if (gameMessage) {
        gameMessage.textContent = 'Perfect match — отключи 15%.';
        gameMessage.classList.add('is-match');
      }
      window.setTimeout(() => showReward(15), 760);
      return;
    }

    attemptsLeft -= 1;
    updateAttempts();
    if (gameMessage) {
      gameMessage.textContent =
        attemptsLeft > 0
          ? 'Почти! Имаш още ' + attemptsLeft + (attemptsLeft === 1 ? ' опит.' : ' опита.')
          : 'Тази глазура беше близо — имаме изненада за теб.';
    }

    window.setTimeout(() => {
      first.classList.remove('is-flipped');
      second.classList.remove('is-flipped');
      first.setAttribute('aria-label', 'Скрита глазура');
      second.setAttribute('aria-label', 'Скрита глазура');
      flippedCards = [];
      boardLocked = false;
      if (attemptsLeft === 0) showReward(10);
    }, 840);
  }

  function openPopup() {
    if (openTimer) {
      window.clearTimeout(openTimer);
      openTimer = null;
    }
    lastFocusedElement = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('elo-glaze-match-lock');
    window.setTimeout(() => dialog?.focus(), 80);
  }

  function closePopup() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('elo-glaze-match-lock');
    if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
  }

  function showSuccessfulSubscription() {
    const successfulReward = getPendingReward();
    setRewardUI(successfulReward);
    markRedeemed({
      reward: successfulReward,
      code: successfulReward === 15 ? 'ELOGLOW15' : 'ELOGLOW10',
      subscribedAt: new Date().toISOString(),
    });
    safeStorageRemove(window.sessionStorage, pendingKey);
    setStep('success');
    openPopup();
  }

  function handleFormError() {
    const pendingReward = getPendingReward();
    setRewardUI(pendingReward);
    setStep('reward');
    openPopup();
    window.setTimeout(() => emailInput?.focus(), 100);
  }

  form?.addEventListener('submit', (event) => {
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }

    setPendingReward(rewardValue);
    setRewardUI(rewardValue);
    if (formError) formError.textContent = '';
    form.classList.add('is-submitting');
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = 'Записване…';
    }
  });

  copyButton?.addEventListener('click', async () => {
    const code = discountCode?.textContent?.trim() || '';
    try {
      await navigator.clipboard.writeText(code);
      copyButton.textContent = 'Копирано';
    } catch (error) {
      const range = document.createRange();
      range.selectNodeContents(discountCode);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      copyButton.textContent = 'Маркирано';
    }

    window.setTimeout(() => {
      copyButton.textContent = 'Копирай';
    }, 1800);
  });

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));

  document.addEventListener('keydown', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      closePopup();
      return;
    }
    if (event.key !== 'Tab' || !dialog) return;

    const focusable = Array.from(
      dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'),
    ).filter((element) => element.offsetParent !== null);

    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (formSuccess && hasPendingReward()) {
    showSuccessfulSubscription();
    return;
  }

  if (formHasErrors && hasPendingReward()) {
    handleFormError();
    return;
  }

  if (hasRedeemed()) {
    root.remove();
    return;
  }

  resetGame();
  const configuredDelay = Number.parseInt(root.dataset.autoOpenDelay, 10);
  const delay = window.Shopify?.designMode ? 800 : (Number.isFinite(configuredDelay) ? configuredDelay : 15000);
  openTimer = window.setTimeout(openPopup, delay);
})();
